import template from "./quote-card.html";
import { truncate } from "lodash";
import ContactUtils from "../../../../common/utils/ContactUtils";

const QuoteCardComponent = {
  bindings: {
    quotes: "<",
    searchText: "<",
    loading: "<",
    onChangeStatus: "&",
  },
  template: template,
  controller: class QuoteCardController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $sce,
      $filter,
      Notification,
      SweetAlertService,
      ModalsManager,
      SecurityManager
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$sce = $sce;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.ModalsManager = ModalsManager;
      this.SecurityManager = SecurityManager;
    }

    getShowQuoteUrl(quote) {
      if (!this.$rootScope.organization)
        throw new Error("Organization was not loaded yet.");
      return this.$sce.trustAsResourceUrl(
        `${this.$rootScope.organization.getDomainUrl()}/show/${quote.token}`
      );
    }

    getStatusClass(status) {
      let statusClass = "";
      switch (status) {
        case "approved":
          statusClass = "quote-approved";
          break;
        case "rejected":
          statusClass = "quote-rejected";
          break;
      }
      return statusClass;
    }

    lastVersionExpirated(quote) {
      return quote.lastVersion.expirationDate < new Date();
    }

    async changeStatusToApproved(quote) {
      await quote.changeStatusToApproved();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.changeStatusToApproved"
        ),
      });
      this.onChangeStatus();
    }

    async changeStatusToRejected(quote) {
      await quote.changeStatusToRejected();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.changeStatusToRejected"
        ),
      });
      this.onChangeStatus();
    }

    async archive(quote) {
      await quote.archive();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.archive"),
      });
      this.onChangeStatus();
    }

    async unarchive(quote) {
      await quote.unarchive();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.unarchive"),
      });
      this.onChangeStatus();
    }

    async clone(quote) {
      const options = {
        edit: false,
        quoteToClone: quote._id,
        name: truncate(
          this.$filter("trans")("quoteCard.clonedQuote") +
            " " +
            quote.description,
          { length: 500 }
        ),
        language: quote.language,
        currency: quote.lastVersion.currency,
        prefix: quote.code.substring(0, quote.code.length - 4),
      };

      const clonedQuote = await this.ModalsManager.openQuoteHeaderModal(
        options
      );
      if (clonedQuote)
        this.$state.go("app.quoteEditor", { quoteId: clonedQuote._id });
    }

    async remove(quote) {
      if (!(await this.SweetAlertService.wantRemoveQuote())) return;
      await quote.delete();
      this.onChangeStatus();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.removeQuote"
        ),
      });
    }

    async createVersion(quote) {
      const newVersionSettings =
        await this.ModalsManager.openCreateQuoteVersionModal(quote);
      if (newVersionSettings) {
        await quote.createVersion(
          newVersionSettings.date,
          newVersionSettings.expirationDate
        );
        this.$state.go("app.quoteEditor", { quoteId: quote._id });
      }
    }

    async launchShareModal(quote) {
      await this.ModalsManager.openQuoteShareModal(quote, true);
    }

    getQuoteContacts(quote) {
      return quote.quoteContacts
        .map(
          ({ contact }) =>
            `${ContactUtils.buildFullName(
              contact
            )}<span style="display: block;">(${contact.email}),</span>`
        )
        .join("");
    }
  },
};

export default QuoteCardComponent;
